module.exports = __webpack_public_path__ + "static/img/11.c03e30e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/sp/11.png
// module id = kbA7
// module chunks = 0